import { Component, OnDestroy, OnInit } from '@angular/core';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { Gtp } from 'src/app/shared/gtp';

import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { MovilSidebar } from 'src/app/models/movil-sidebar.model';

@Component({
  selector: 'app-control-vehiculos-listavehiculos',
  templateUrl: './control-vehiculos-listavehiculos.component.html',
  styleUrls: ['./control-vehiculos-listavehiculos.component.scss']
})
export class ControlVehiculosLista implements OnInit, OnDestroy {
  
  public loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  public movilAll: boolean = false;
  public totalVehiculos = [];
  public perfilData = {};
  public configVeh = {
    centrodecosto: null,
    consumocada100: null,
    nromovil: null,
    velmax: null,
  };

  constructor(
    public gtp: Gtp,
    private ctrlVehiculo: ControlVehiculosService,
    public listamovilesservice: ListaMovilesService,
  ) {
    this.getVehiculos();
  }
  
  getVehiculos(){
    this.listamovilesservice.getListaMoviles().subscribe(data => {
      if (data) {
        let moviles = [];
        Object.entries(data).forEach(item => {
          var marker = new MovilSidebar(item[1]);          
          marker.active = this.checkEventEnable(marker.cod_equipo_rastreo);
          moviles.push(marker);
        });
        this.totalVehiculos = moviles.sort(this.gtp.orderMoviles);
      }
    });
  }

  checkEventEnable(cod_equipo_rastreo) {
    let enable = false;
    this.ctrlVehiculo.VehiculosConfig.forEach(ev => {
        if (ev.cod_equipo_rastreo == cod_equipo_rastreo) { enable = true; }
    });
    return enable;
  }
  
  ngOnInit(): void {
  }

  ngOnDestroy():void{    
  }

  saveParams() {
    this.loading = true;
    let cleanVehiculos = [];
    let totalVehiculos = JSON.parse(JSON.stringify(this.totalVehiculos));
    totalVehiculos.forEach(val => {
      if(val.active){ 
        let movil = {
          cod_equipo_rastreo: val.cod_equipo_rastreo,
          des_equipo_ratreo: val.des_equipo_ratreo,
        }
        cleanVehiculos.push(movil); 
      }
    });
    this.perfilData = cleanVehiculos;    
    this.ctrlVehiculo.setVehiculosConfig(this.perfilData);
    this.loading = false;
    console.log('Actualizando...');
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }
  
  toggleAll() {
    this.totalVehiculos.forEach((val, i)=> {
      this.totalVehiculos[i].active = !this.movilAll;      
    });
    this.movilAll = !this.movilAll;
  }

}
